// extracted by mini-css-extract-plugin
export default {"container":"Aside_container__U8SO5"};